var map = {
	"./boy.jpg": 488,
	"./default.png": 736,
	"./girl.jpg": 508,
	"./man.jpg": 343,
	"./man2.jpg": 280,
	"./man3.jpg": 740,
	"./man4.jpg": 452,
	"./woman.jpg": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;